/**
 * Coolwindshades Product Customizer v8 (metafield-driven)
 * Reads base price + selected options from DOM data-attributes,
 * collects properties on Add to Cart, submits via /cart/add.js.
 */
(function() {
  'use strict';

  var C = {
    basePrice: 0,
    sel: {},
    qty: 1,
    booting: true,
    settingDefaults: false,
    defaultMainImage: null,
    sizeLimits: null,
    pricing: null,
    priceTables: null,
    pendingProps: null,

    /* Modules that require dimension confirm before user can pick */
    gated: [
      'power_type','motor_type',
      'valance_type','bottom_rod','roll_type',
      'motor_side','cord_position',
      'remote_type','solar_panel','usb_charger',
      'light_blockers','side_tracks'
    ],

    /* Pretty label overrides for line item property keys */
    LABEL_MAP: {
      'control_type': 'Control Type',
      'mount_type': 'Mount Type',
      'power_type': 'Power Type',
      'motor_type': 'Motor Type',
      'valance_type': 'Valance',
      'bottom_rod': 'Bottom Rod',
      'roll_type': 'Roll Type',
      'motor_side': 'Motor Side',
      'cord_position': 'Cord Position',
      'remote_type': 'Remote',
      'solar_panel': 'Solar Panel',
      'usb_charger': 'USB Charger',
      'light_blockers': 'Light Blockers',
      'side_tracks': 'Side Tracks',
      'warranty': 'Extended Service',
      'color': 'Color'
    },

    init: function() {
      try {
        var wrap = document.querySelector('.customizer-wrapper');
        if (!wrap) return;
        this.basePrice = parseFloat(wrap.dataset.basePrice) || 0;
        var mainImg = document.getElementById('cw-main-image');
        this.defaultMainImage = mainImg ? mainImg.src : null;
        try {
          var lim = document.getElementById('cw-size-limits');
          if (lim) this.sizeLimits = JSON.parse(lim.textContent);
          var pr = document.getElementById('cw-pricing');
          if (pr) { var pj = JSON.parse(pr.textContent); if (pj && Object.keys(pj).length) this.pricing = pj; }
          var pt = document.getElementById('cw-price-tables');
          if (pt) this.priceTables = JSON.parse(pt.textContent);
        } catch(e) { console.error('CW size limits parse error:', e); }
        this.bindCards();
        this.bindMeasurement();
        this.bindWarranty();
        this.bindAddons();
        this.bindQuantity();
        this.bindAddToCart();
        this.bindModal();
        this.bindHoverPreview();
        this.fixDescriptionLinks();
        this.labelDropdownPrices();
        this.setDefaults();
        this.booting = false;
        this.applyVisibility();
        this.applySizeLimits();
        this.updatePrice();
      } catch(e) { console.error('CW init error:', e); }
    },

    labelDropdownPrices: function() {
      try {
        var tableEl = document.getElementById('cw-price-tables');
        if (!tableEl) return;
        var tables = JSON.parse(tableEl.textContent);
        var wSel = document.getElementById('cw-width-int');
        var hSel = document.getElementById('cw-height-int');
        if (wSel && tables.width) {
          for (var i = 1; i < wSel.options.length; i++) {
            var v = wSel.options[i].value, p = tables.width[v];
            if (p > 0) wSel.options[i].textContent = v + '"  (+$' + p + ')';
          }
        }
        if (hSel && tables.height) {
          for (var j = 1; j < hSel.options.length; j++) {
            var v2 = hSel.options[j].value, p2 = tables.height[v2];
            if (p2 > 0) hSel.options[j].textContent = v2 + '"  (+$' + p2 + ')';
          }
        }
      } catch(e) {}
    },

    fixDescriptionLinks: function() {
      try {
        document.querySelectorAll('.customizer-module__description a').forEach(function(a) {
          a.setAttribute('target', '_blank');
          a.setAttribute('rel', 'noopener noreferrer');
        });
      } catch(e) {}
    },

    bindHoverPreview: function() {
      var cards = document.querySelectorAll('.option-card, .color-card');
      cards.forEach(function(card) {
        if (card.querySelector('.option-card__tooltip')) return;
        var img = card.querySelector('.option-card__image, .color-card__swatch');
        if (!img || !img.src) return;
        var preview = document.createElement('div');
        preview.className = 'cw-hover-preview';
        var previewImg = document.createElement('img');
        previewImg.src = img.src;
        previewImg.alt = 'Preview';
        preview.appendChild(previewImg);
        card.appendChild(preview);
        card.addEventListener('mouseenter', function() {
          var rect = card.getBoundingClientRect();
          preview.classList.remove('cw-hover-preview--above', 'cw-hover-preview--below');
          if (rect.top > 340) {
            preview.classList.add('cw-hover-preview--above');
          } else {
            preview.classList.add('cw-hover-preview--below');
          }
        });
      });
    },

    bindModal: function() {
      var self = this;
      var closeBtn = document.getElementById('cw-modal-close');
      var backBtn = document.getElementById('cw-modal-back');
      var confirmBtn = document.getElementById('cw-modal-confirm');
      var overlay = document.getElementById('cw-cart-modal');
      if (closeBtn) closeBtn.addEventListener('click', function() { self.hideModal(); });
      if (backBtn) backBtn.addEventListener('click', function() { self.hideModal(); });
      if (overlay) overlay.addEventListener('click', function(e) { if (e.target === overlay) self.hideModal(); });
      if (confirmBtn) confirmBtn.addEventListener('click', function() { self.submitCart(); });
    },

    showModal: function(props) {
      var body = document.getElementById('cw-modal-body');
      var overlay = document.getElementById('cw-cart-modal');
      if (!body || !overlay) return;
      var html = '<table class="cw-modal__table">';
      var keys = Object.keys(props);
      for (var i = 0; i < keys.length; i++) {
        if (keys[i].charAt(0) === '_') continue;
        html += '<tr><td class="cw-modal__key">' + keys[i] + '</td><td class="cw-modal__val">' + props[keys[i]] + '</td></tr>';
      }
      var priceEl = document.getElementById('cw-dynamic-price');
      if (priceEl) html += '<tr class="cw-modal__total"><td>Unit Price</td><td>' + priceEl.textContent + '</td></tr>';
      if (this.qty > 1 && priceEl) {
        var total = parseFloat(priceEl.textContent.replace('$','')) * this.qty;
        html += '<tr class="cw-modal__total"><td>Qty &times; ' + this.qty + ' Total</td><td>$' + total.toFixed(2) + '</td></tr>';
      }
      html += '</table>';
      body.innerHTML = html;
      overlay.style.display = 'flex';
    },

    hideModal: function() {
      var overlay = document.getElementById('cw-cart-modal');
      if (overlay) overlay.style.display = 'none';
    },

    isGated: function() {
      try {
        var w = document.getElementById('cw-width-int'),
            h = document.getElementById('cw-height-int'),
            cb = document.getElementById('cw-dimension-confirm');
        if (!w || !h || !cb) return false;
        if (!w.value || !h.value) return true;
        return !cb.checked;
      } catch(e) { return false; }
    },

    gateWarn: function() {
      try {
        var w = document.getElementById('cw-width-int'), h = document.getElementById('cw-height-int');
        var lbl = document.getElementById('cw-dimension-confirm-label'),
            errDiv = document.getElementById('cw-dimension-error');
        if (!w || !w.value || !h || !h.value) {
          if (w) {
            w.scrollIntoView({ behavior: 'smooth', block: 'center' });
            w.style.borderColor = '#d32f2f';
            setTimeout(function() { if (w) w.style.borderColor = ''; }, 2500);
          }
          return;
        }
        if (errDiv) errDiv.style.display = 'block';
        if (lbl) {
          lbl.style.display = 'flex';
          lbl.classList.add('gate-highlight');
          lbl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function() { if (lbl) lbl.classList.remove('gate-highlight'); }, 2500);
        }
      } catch(e) {}
    },

    bindCards: function() {
      var self = this;
      document.querySelectorAll('.option-cards, .color-cards').forEach(function(container) {
        var mod = container.dataset.module;
        container.querySelectorAll('.option-card, .color-card').forEach(function(card) {
          card.addEventListener('click', function() {
            try {
              if (!self.booting && !self.settingDefaults && self.gated.indexOf(mod) !== -1 && self.isGated()) {
                self.gateWarn();
                return;
              }
              container.querySelectorAll('.option-card, .color-card').forEach(function(c) { c.classList.remove('selected'); });
              card.classList.add('selected');
              self.sel[mod] = {
                label: card.dataset.label,
                price: parseFloat(card.dataset.price) || 0,
                control: card.dataset.control || null,
                priceRule: card.dataset.priceRule || null
              };
              if (mod === 'color') {
                /* 主图跟随面料切换：用 gallery_image，没有就回退产品原主图。
                   注意不要用色卡缩略图（data-image），那是面料特写不是场景图。 */
                var main = document.getElementById('cw-main-image');
                if (main) {
                  var g = card.dataset.gallery;
                  if (g) { main.src = g; }
                  else if (self.defaultMainImage) { main.src = self.defaultMainImage; }
                }
              }
              if (mod === 'control_type') { self.applyVisibility(); }
              if (mod === 'control_type' || mod === 'color') { self.applySizeLimits(); }
              if (mod === 'color') { self.recalcMeasurement(); }
              self.updatePrice();
            } catch(e) {}
          });
        });
      });
    },

    bindMeasurement: function() {
      var wI = document.getElementById('cw-width-int'), wF = document.getElementById('cw-width-frac');
      var hI = document.getElementById('cw-height-int'), hF = document.getElementById('cw-height-frac');
      var field = document.getElementById('cw-confirm-dimensions');
      var lbl = document.getElementById('cw-dimension-confirm-label');
      var cb = document.getElementById('cw-dimension-confirm');
      var errDiv = document.getElementById('cw-dimension-error');
      if (!wI || !wF || !hI || !hF) return;

      var priceTables = { width: {}, height: {} };
      try {
        var tableEl = document.getElementById('cw-price-tables');
        if (tableEl) priceTables = JSON.parse(tableEl.textContent);
      } catch(e) { console.error('Price table parse error:', e); }

      var self = this;
      var isInitialRun = true;
      function update() {
        try {
          var wi = wI.value, wf = wF.value || '0', hi = hI.value, hf = hF.value || '0';
          if (wi && hi) {
            var ws = wf !== '0' ? wi + ' ' + wf : wi;
            var hs = hf !== '0' ? hi + ' ' + hf : hi;
            if (field) field.value = ws + '"W x ' + hs + '"H';
            if (lbl) lbl.style.display = 'flex';
            if (!isInitialRun) {
              if (cb) { cb.checked = false; if (lbl) lbl.classList.remove('confirmed'); }
            } else {
              if (cb && cb.checked && lbl) lbl.classList.add('confirmed');
            }
            if (errDiv) errDiv.style.display = 'none';

            var tbl = self.sizeTables();
            var widthPrice = parseFloat((tbl.width && tbl.width[wi]) || 0) || 0;
            var heightPrice = parseFloat((tbl.height && tbl.height[hi]) || 0) || 0;
            var sizePrice = widthPrice + heightPrice;

            self.sel['measurement'] = {
              label: field ? field.value : '',
              width: wi, widthFraction: wf, height: hi, heightFraction: hf,
              sizePrice: sizePrice, widthPrice: widthPrice, heightPrice: heightPrice
            };
          } else {
            if (field) field.value = '';
            if (lbl) lbl.style.display = 'none';
            delete self.sel['measurement'];
          }
          self.updatePrice();
        } catch(e) {}
      }
      [wI, wF, hI, hF].forEach(function(el) { el.addEventListener('change', update); });
      if (cb) cb.addEventListener('change', function() {
        try {
          if (cb.checked) {
            if (lbl) lbl.classList.add('confirmed');
            if (errDiv) errDiv.style.display = 'none';
          } else {
            if (lbl) lbl.classList.remove('confirmed');
          }
        } catch(e) {}
      });
      if (wI.value || hI.value) update();
      isInitialRun = false;
    },

    bindWarranty: function() {
      var self = this;
      document.querySelectorAll('.warranty-option').forEach(function(opt) {
        opt.addEventListener('click', function() {
          try {
            if (!self.booting && self.isGated()) { self.gateWarn(); return; }
            var radio = opt.querySelector('input[type="radio"]');
            if (radio) radio.checked = true;
            document.querySelectorAll('.warranty-option').forEach(function(o) { o.classList.remove('selected'); });
            opt.classList.add('selected');
            self.sel['warranty'] = { label: opt.dataset.label, price: parseFloat(opt.dataset.price) || 0 };
            self.updatePrice();
          } catch(e) {}
        });
      });
    },

    bindAddons: function() {
      var self = this;
      var sideTracks = document.getElementById('cw-side-tracks');
      if (sideTracks) {
        sideTracks.addEventListener('change', function() {
          try {
            if (!self.booting && self.gated.indexOf('side_tracks') !== -1 && self.isGated()) {
              sideTracks.checked = false;
              self.gateWarn();
              return;
            }
            if (sideTracks.checked) {
              self.sel['side_tracks'] = { label: 'Side Tracks', price: parseFloat(sideTracks.dataset.price) || 0 };
            } else {
              delete self.sel['side_tracks'];
            }
            self.updatePrice();
          } catch(e) {}
        });
      }
    },

    bindQuantity: function() {
      var self = this,
          m = document.getElementById('cw-qty-minus'),
          p = document.getElementById('cw-qty-plus'),
          inp = document.getElementById('cw-qty-input');
      if (!m || !p || !inp) return;
      m.addEventListener('click', function() {
        var v = parseInt(inp.value) || 1;
        if (v > 1) { inp.value = --v; self.qty = v; self.updatePrice(); }
      });
      p.addEventListener('click', function() {
        var v = parseInt(inp.value) || 1;
        inp.value = ++v; self.qty = v; self.updatePrice();
      });
      inp.addEventListener('change', function() {
        var v = parseInt(inp.value) || 1;
        if (v < 1) v = 1;
        inp.value = v; self.qty = v; self.updatePrice();
      });
    },

    currentControl: function() {
      var s = this.sel['control_type'];
      return (s && s.control) || 'motorized';
    },

    /* 无绳分档：(宽>=60 且 高>=60) 或 宽>=80 或 高>=80 -> 30，否则 20 */
    cordlessSurcharge: function() {
      var m = this.sel['measurement'];
      var base = 20, high = 30;
      var c = this.pricing && this.pricing.control && this.pricing.control.cordless;
      if (c) { if (c.base != null) base = parseFloat(c.base) || 0;
               if (c.high != null) high = parseFloat(c.high) || 0; }
      if (!m) return base;
      var w = parseInt(m.width, 10) || 0, h = parseInt(m.height, 10) || 0;
      if ((w >= 60 && h >= 60) || w >= 80 || h >= 80) return high;
      return base;
    },

    isHidden: function(el) {
      return !!(el && el.classList && el.classList.contains('cw-hidden'));
    },

    /* 按当前 Control Type 与品类切换模块显隐。
       隐藏的模块会从 sel 里移除，因此不计价、不校验、不进购物车属性。 */
    applyVisibility: function() {
      var self = this;
      try {
        var ctrl = this.currentControl();
        var wrap = document.querySelector('.customizer-wrapper');
        var cat = (wrap && wrap.dataset.category) || '';
        document.querySelectorAll('.customizer-module').forEach(function(el) {
          var name = el.dataset.moduleName;
          var showFor = el.dataset.showFor;
          var needCat = el.dataset.category;
          var visible = true;
          if (showFor && showFor.split(',').indexOf(ctrl) === -1) visible = false;
          if (needCat && cat && needCat.split(',').indexOf(cat) === -1) visible = false;

          if (visible) {
            if (el.classList.contains('cw-hidden')) {
              el.classList.remove('cw-hidden');
              var con = el.querySelector('.option-cards, .color-cards');
              if (con && !con.querySelector('.selected')) {
                var def = con.querySelector('[data-default="true"]') ||
                          con.querySelector('.option-card, .color-card');
                if (def) {
                  self.settingDefaults = true;
                  try { def.click(); } finally { self.settingDefaults = false; }
                }
              }
            }
          } else {
            el.classList.add('cw-hidden');
            if (name) delete self.sel[name];
            var con2 = el.querySelector('.option-cards, .color-cards');
            if (con2) {
              con2.querySelectorAll('.selected').forEach(function(c) {
                c.classList.remove('selected');
              });
            }
          }
        });
      } catch(e) { console.error('CW applyVisibility error:', e); }
    },

    /* 当前控制方式 + 所选面料共同决定的尺寸上下限 */
    /* 当前面料所属价格组；未配置则返回 null，走旧的 product.price 逻辑 */
    currentPriceGroup: function() {
      var card = document.querySelector('[data-module="color"] .selected');
      return (card && card.dataset.priceGroup) || null;
    },

    /* 起价：metafield 的 base[组] 优先，否则回退 product.price */
    effectiveBase: function() {
      var g = this.currentPriceGroup();
      if (this.pricing && this.pricing.base && g && this.pricing.base[g] != null) {
        return parseFloat(this.pricing.base[g]) || 0;
      }
      return this.basePrice;
    },

    /* 尺寸加价表：metafield 的 size[组] 优先，否则回退内置表 */
    sizeTables: function() {
      var g = this.currentPriceGroup();
      if (this.pricing && this.pricing.size && g && this.pricing.size[g]) {
        return this.pricing.size[g];
      }
      if (this.pricing && this.pricing.size && this.pricing.size['default']) {
        return this.pricing.size['default'];
      }
      return this.priceTables || { width: {}, height: {} };
    },

    sizePrice: function(wi, hi) {
      var t = this.sizeTables();
      var w = (t.width && t.width[wi]) || 0;
      var h = (t.height && t.height[hi]) || 0;
      return (parseFloat(w) || 0) + (parseFloat(h) || 0);
    },

    /* 价格组变化后重算已选尺寸的加价 */
    recalcMeasurement: function() {
      try {
        var m = this.sel['measurement'];
        if (!m) return;
        var t = this.sizeTables();
        m.widthPrice  = parseFloat((t.width  && t.width[m.width])  || 0) || 0;
        m.heightPrice = parseFloat((t.height && t.height[m.height]) || 0) || 0;
        m.sizePrice = m.widthPrice + m.heightPrice;
        this.updatePrice();
      } catch(e) { console.error('CW recalcMeasurement error:', e); }
    },

    currentLimits: function() {
      var L = this.sizeLimits || {};
      var d = L[this.currentControl()] || { wMin: 20, wMax: 108, hMin: 20, hMax: 110 };
      var lim = { wMin: d.wMin, wMax: d.wMax, hMin: d.hMin, hMax: d.hMax };
      /* 面料级宽度上限（如 Linen 98"）取更严的那个 */
      var card = document.querySelector('[data-module="color"] .selected');
      if (card && card.dataset.maxWidth) {
        var fw = parseInt(card.dataset.maxWidth, 10);
        if (fw && fw < lim.wMax) lim.wMax = fw;
      }
      return lim;
    },

    /* 置灰越界选项；当前已选值越界则清空并提示，不静默改值 */
    applySizeLimits: function() {
      var self = this;
      try {
        var lim = this.currentLimits();
        var msgs = [];
        [['cw-width-int', lim.wMin, lim.wMax, 'Width'],
         ['cw-height-int', lim.hMin, lim.hMax, 'Height']].forEach(function(cfg) {
          var el = document.getElementById(cfg[0]);
          if (!el) return;
          var min = cfg[1], max = cfg[2], name = cfg[3];
          var opts = el.options, cleared = false;
          for (var i = 0; i < opts.length; i++) {
            var o = opts[i];
            if (!o.value) continue;
            var v = parseInt(o.value, 10);
            var bad = (v < min || v > max);
            o.disabled = bad;
            o.style.color = bad ? '#bbb' : '';
          }
          if (el.value) {
            var cur = parseInt(el.value, 10);
            if (cur < min || cur > max) {
              el.value = '';
              cleared = true;
            }
          }
          if (cleared) {
            msgs.push(name + ' must be between ' + min + '" and ' + max + '" for this combination — please re-select.');
          }
        });

        /* 尺寸被清空后，测量结果与确认勾选一并作废 */
        if (msgs.length) {
          delete self.sel['measurement'];
          var field = document.getElementById('cw-confirm-dimensions');
          if (field) field.value = '';
          var lbl = document.getElementById('cw-dimension-confirm-label');
          if (lbl) { lbl.style.display = 'none'; lbl.classList.remove('confirmed'); }
          var cb = document.getElementById('cw-dimension-confirm');
          if (cb) cb.checked = false;
        }
        var note = document.getElementById('cw-size-limit-note');
        if (note) {
          note.textContent = msgs.join(' ');
          note.style.display = msgs.length ? 'block' : 'none';
        }
      } catch(e) { console.error('CW applySizeLimits error:', e); }
    },

    getCalculatedPrice: function() {
      var total = this.effectiveBase(), m = this.sel['measurement'];
      if (m && m.sizePrice) total += m.sizePrice;
      var keys = Object.keys(this.sel);
      for (var i = 0; i < keys.length; i++) {
        if (keys[i] === 'measurement') continue;
        var s = this.sel[keys[i]];
        if (!s) continue;
        if (keys[i] === 'control_type' && s.priceRule === 'cordless-tiered') {
          total += this.cordlessSurcharge();
          continue;
        }
        if (s.price) total += s.price;
      }
      return total;
    },

    updatePrice: function() {
      try {
        var total = this.getCalculatedPrice();
        var pe = document.getElementById('cw-dynamic-price');
        if (pe) pe.textContent = '$' + total.toFixed(2);
        var te = document.getElementById('cw-total-price');
        if (te) {
          if (this.qty > 1) {
            te.textContent = 'Total: $' + (total * this.qty).toFixed(2);
            te.style.display = 'block';
          } else {
            te.style.display = 'none';
          }
        }
      } catch(e) {}
    },

    setDefaults: function() {
      try {
        this.settingDefaults = true;
        document.querySelectorAll('.option-cards, .color-cards').forEach(function(c) {
          var def = c.querySelector('[data-default="true"]') || c.querySelector('.option-card, .color-card');
          if (def) def.click();
        });
        var fw = document.querySelector('.warranty-option');
        if (fw) fw.click();
      } catch(e) {}
      this.settingDefaults = false;
    },

    bindAddToCart: function() {
      var btn = document.getElementById('cw-add-to-cart');
      if (!btn) return;
      var self = this;
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        try {
          self.syncDOM();
          if (!self.validate()) return;
          var props = {}, keys = Object.keys(self.sel);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i], s = self.sel[key];
            if (!s) continue;
            if (key === 'measurement') {
              props['Dimensions'] = s.label;
              props['Width'] = s.width + ' ' + (s.widthFraction || '0') + '"';
              props['Height'] = s.height + ' ' + (s.heightFraction || '0') + '"';
              if (s.widthPrice > 0) props['Width Surcharge'] = '+$' + s.widthPrice.toFixed(2);
              if (s.heightPrice > 0) props['Height Surcharge'] = '+$' + s.heightPrice.toFixed(2);
            } else {
              var lbl = self.fmtLabel(key);
              props[lbl] = s.price > 0 ? s.label + ' (+$' + s.price.toFixed(2) + ')' : s.label;
            }
          }
          var room = document.getElementById('cw-room-label');
          if (room && room.value.trim()) props['Room Label'] = room.value.trim();
          var calcPrice = self.getCalculatedPrice();
          props['_Calculated Price'] = '$' + calcPrice.toFixed(2);
          if (self.qty > 1) props['_Calculated Total'] = '$' + (calcPrice * self.qty).toFixed(2);
          self.pendingProps = props;
          self.showModal(props);
        } catch(e) { console.error('ATC error:', e); }
      });
    },

    submitCart: function() {
      var btn = document.getElementById('cw-add-to-cart'),
          confirmBtn = document.getElementById('cw-modal-confirm'),
          self = this;
      if (!this.pendingProps || !btn) return;
      this.hideModal();
      var vid = btn.dataset.variantId;
      btn.disabled = true; btn.textContent = 'Adding...';
      if (confirmBtn) { confirmBtn.disabled = true; confirmBtn.textContent = 'Processing...'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(vid), quantity: self.qty, properties: self.pendingProps }] })
      })
      .then(function(r) { if (!r.ok) throw new Error('Failed'); return r.json(); })
      .then(function() {
        btn.textContent = '\u2713 Added!';
        btn.style.background = '#388e3c';
        setTimeout(function() { window.location.href = '/cart'; }, 1000);
      })
      .catch(function(err) {
        console.error('Cart error:', err);
        btn.disabled = false; btn.textContent = 'Add to Cart';
        if (confirmBtn) { confirmBtn.disabled = false; confirmBtn.textContent = 'Confirm & Add to Cart'; }
        alert('Failed to add to cart.');
      });
    },

    syncDOM: function() {
      var self = this;
      try {
        document.querySelectorAll('.option-cards, .color-cards').forEach(function(c) {
          var mod = c.dataset.module, s = c.querySelector('.selected');
          var owner = c.closest ? c.closest('.customizer-module') : null;
          if (self.isHidden(owner)) { delete self.sel[mod]; return; }
          if (s) self.sel[mod] = {
            label: s.dataset.label,
            price: parseFloat(s.dataset.price) || 0,
            control: s.dataset.control || null,
            priceRule: s.dataset.priceRule || null
          };
        });
        var sw = document.querySelector('.warranty-option.selected');
        if (sw) self.sel['warranty'] = { label: sw.dataset.label, price: parseFloat(sw.dataset.price) || 0 };
        var sideTracks = document.getElementById('cw-side-tracks');
        if (sideTracks) {
          if (sideTracks.checked) {
            self.sel['side_tracks'] = { label: 'Side Tracks', price: parseFloat(sideTracks.dataset.price) || 0 };
          } else {
            delete self.sel['side_tracks'];
          }
        }
      } catch(e) {}
    },

    validate: function() {
      var valid = true, firstBad = null;
      try {
        var old = document.querySelectorAll('.field-error.dynamic-error');
        for (var i = 0; i < old.length; i++) { if (old[i] && old[i].parentNode) old[i].parentNode.removeChild(old[i]); }
      } catch(e) {}
      try {
        var wI = document.getElementById('cw-width-int');
        if (wI && !wI.value) { this.addError(wI, 'Please select width'); if (!firstBad) firstBad = wI; valid = false; }
      } catch(e) {}
      try {
        var hI = document.getElementById('cw-height-int');
        if (hI && !hI.value) { this.addError(hI, 'Please select height'); if (!firstBad) firstBad = hI; valid = false; }
      } catch(e) {}
      try {
        var wC = document.getElementById('cw-width-int'),
            hC = document.getElementById('cw-height-int');
        var cb = document.getElementById('cw-dimension-confirm'),
            errD = document.getElementById('cw-dimension-error');
        if (cb && wC && wC.value && hC && hC.value && !cb.checked) {
          if (errD) errD.style.display = 'block';
          if (!firstBad) firstBad = errD || cb;
          valid = false;
        } else if (errD) {
          errD.style.display = 'none';
        }
      } catch(e) {}
      try {
        var mods = document.querySelectorAll('.customizer-module[data-required="true"]');
        for (var j = 0; j < mods.length; j++) {
          var mod = mods[j];
          if (!mod) continue;
          var name = mod.dataset.moduleName;
          if (name === 'measurement') continue;
          if (this.isHidden(mod)) continue;
          var con = mod.querySelector('.option-cards, .color-cards');
          if (con && !con.querySelector('.selected')) {
            this.addError(con, 'Please select ' + (this.LABEL_MAP[name] || name.replace(/_/g, ' ')));
            if (!firstBad) firstBad = con;
            valid = false;
          }
        }
      } catch(e) {}
      if (!valid && firstBad) {
        try { firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch(e) {}
      }
      return valid;
    },

    addError: function(el, msg) {
      try {
        if (!el || !el.parentNode) return;
        var d = document.createElement('div');
        d.className = 'field-error dynamic-error';
        d.textContent = msg;
        d.style.cssText = 'display:block;color:#d32f2f;font-size:13px;margin-top:6px;font-weight:500;';
        el.parentNode.insertBefore(d, el.nextSibling);
        setTimeout(function() { try { if (d && d.parentNode) d.parentNode.removeChild(d); } catch(e) {} }, 5000);
      } catch(e) {}
    },

    fmtLabel: function(k) {
      if (this.LABEL_MAP[k]) return this.LABEL_MAP[k];
      return k.replace(/_/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { C.init(); });
  } else {
    C.init();
  }
})();
